var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZoomIn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2005 4.08325C8.01569 4.08325 4.61719 7.48175 4.61719 11.6666C4.61719 15.8514 8.01569 19.2499 12.2005 19.2499C16.3854 19.2499 19.7839 15.8514 19.7839 11.6666C19.7839 7.48175 16.3854 4.08325 12.2005 4.08325ZM12.2005 5.24992C15.7425 5.24992 18.6172 8.12459 18.6172 11.6666C18.6172 15.2086 15.7425 18.0833 12.2005 18.0833C8.65852 18.0833 5.78385 15.2086 5.78385 11.6666C5.78385 8.12459 8.65852 5.24992 12.2005 5.24992Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2797 22.9203L17.5609 16.2026C17.3334 15.9751 16.9636 15.9751 16.7361 16.2026C16.5086 16.4301 16.5086 16.7999 16.7361 17.0274L23.4537 23.7463C23.6824 23.9738 24.0511 23.9738 24.2797 23.7463C24.5072 23.5176 24.5072 23.1489 24.2797 22.9203Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28353 12.2499H15.1169C15.4389 12.2499 15.7002 11.9886 15.7002 11.6666C15.7002 11.3446 15.4389 11.0833 15.1169 11.0833H9.28353C8.96153 11.0833 8.7002 11.3446 8.7002 11.6666C8.7002 11.9886 8.96153 12.2499 9.28353 12.2499Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7839 14.5832V8.74984C12.7839 8.42784 12.5225 8.1665 12.2005 8.1665C11.8785 8.1665 11.6172 8.42784 11.6172 8.74984V14.5832C11.6172 14.9052 11.8785 15.1665 12.2005 15.1665C12.5225 15.1665 12.7839 14.9052 12.7839 14.5832Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomIn);
export default __webpack_public_path__ + "static/media/zoom-in.e79696095407bafcd8690e6f425dcfd6.svg";
export { ForwardRef as ReactComponent };